import { createContext } from "react";

const SidebarContext = createContext(null);

export default SidebarContext;
